import { IonContent, IonHeader, IonLoading, IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import Header from '../../components/header'
import BroadcastDetail from '../../marketing/broadcasts/components/broadcast-detail'
import { useBroadcastDetail } from '../../marketing/broadcasts/queries'

function BroadcastDetailPage() {
  const { broadcastId } = useParams<{ broadcastId: string }>()
  const broadcastQuery = useBroadcastDetail(broadcastId)

  return (
    <IonPage>
      <IonHeader>
        <Header
          title={broadcastQuery.data?.title ?? ' '}
          backRef="/broadcasts"
          btn={null}
        />
      </IonHeader>

      <IonContent>
        {broadcastQuery.data ? (
          <>
            <BroadcastDetail broadcast={broadcastQuery.data} />
          </>
        ) : (
          <IonLoading isOpen message="Loading Broadcast..." />
        )}
      </IonContent>
    </IonPage>
  )
}

export default BroadcastDetailPage
